<div
  #mapContainer
  class="leaflet-map"
  [style.height.px]="heightPx"
></div>

